import { API, graphqlOperation } from 'aws-amplify';
import { Dispatch } from 'redux';
import {
  deleteFavoriteProduct,
  createFavoriteProduct,
  createFavoriteProductList,
} from '../../../graphql/mutations';
import { searchFavoriteProductLists } from '../../../graphql/queries';

import { Product } from '~domain/product/Product';

import {
  addedFavoriteProduct,
  removedFavoriteProduct,
} from '~redux/favorite/reducers/product';
import { FavoriteProductList } from '~redux/favoritelist/actions';
import {
  DeleteFavoriteProductMutation,
  DeleteFavoriteProductMutationVariables,
} from '~types/api';
import { executeQuery } from '~utils/graphql';
import { productSaved } from '~utils/segment';

export const addFavoriteProduct = (
  account_id: string,
  list_id: string,
  product: Product
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    const res = await API.graphql<any>(
      graphqlOperation(createFavoriteProduct, {
        input: {
          account_id: account_id,
          favorite_list_id: list_id,
          product_id: product.id,
        },
      })
    );
    const {
      data: { createFavoriteProduct: item },
    } = res;

    dispatch(addedFavoriteProduct(item));

    productSaved({
      brand_id: item?.product?.product_brand_id,
      product_id: item?.product?.id,
      sku: item?.product?.sku,
      category: item?.product?.product_category,
      category2: item?.product?.product_subcategory,
      name: item?.product?.product_name,
      brand: item?.product?.brand?.brand_name,
      price: Math.round(
        item?.product?.product_retail_price *
          ((item?.product?.product_wholesale_rate ?? 0) / 100)
      ),
    });
  };
};

export const addDefaultFavoriteProduct = (
  account_id: string,
  product: Product
) => {
  const defaultListId = `${account_id}defFavList`;
  const defaultListName = 'お気に入りの商品';

  return async (dispatch: Dispatch): Promise<void> => {
    const exist = await API.graphql<any>(
      graphqlOperation(searchFavoriteProductLists, {
        filter: { account_id: { eq: account_id }, id: { eq: defaultListId } },
      })
    );
    if (!exist?.data?.searchFavoriteProductLists?.items?.length) {
      const favoriteProductListData: FavoriteProductList = {
        id: defaultListId,
        account_id: account_id,
        list_name: defaultListName,
        order: 0,
      };
      await API.graphql<any>(
        graphqlOperation(createFavoriteProductList, {
          input: favoriteProductListData,
        })
      );
    }

    const res = await API.graphql<any>(
      graphqlOperation(createFavoriteProduct, {
        input: {
          account_id: account_id,
          favorite_list_id: defaultListId,
          product_id: product.id,
        },
      })
    );
    const {
      data: { createFavoriteProduct: item },
    } = res;

    dispatch(addedFavoriteProduct(item));

    productSaved({
      brand_id: item?.product?.product_brand_id,
      product_id: item?.product?.id,
      sku: item?.product?.sku,
      category: item?.product?.product_category,
      category2: item?.product?.product_subcategory,
      name: item?.product?.product_name,
      brand: item?.product?.brand?.brand_name,
      price: Math.round(
        item?.product?.product_retail_price *
          ((item?.product?.product_wholesale_rate ?? 0) / 100)
      ),
    });
  };
};

export const removeFavoriteProduct = (id: string) => {
  return async (dispatch: Dispatch): Promise<void> => {
    const res = await executeQuery<
      DeleteFavoriteProductMutation,
      DeleteFavoriteProductMutationVariables
    >(deleteFavoriteProduct, {
      input: { id },
    });
    const item = res.data?.deleteFavoriteProduct;
    dispatch(
      removedFavoriteProduct({
        listId: item?.favorite_list_id!,
        productId: item?.product_id!,
      })
    );
  };
};
